import {FormControl} from '@angular/forms';
import {OrderStatus} from '../../dto/order-status';
import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild} from '@angular/core';
import {RoleService} from '../../services/role.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {OrdersService} from '../services/orders.service';
import {Order, OrderWithIdent} from '../../dto/order';
import {FileHelper} from '../../helpers/file-helper';
import {toDateString} from '../../providers/app-date-adapter';
import {MatButtonToggle} from '@angular/material/button-toggle';
import {IdentStatus} from '../../dto/ident-status';
import {OrdersCancellationsInternService} from '../services/orders-cancellations-intern.service';
import {OrderCancellationStatus} from '../../dto/order-cancellation-status';
import {byNumeric} from 'iso-country-codes';

@Component({
  selector: 'app-orders-cancellations-intern',
  templateUrl: './orders-cancellations-intern.component.html',
  styleUrls: ['./orders-cancellations-intern.component.css'],
})
export class OrdersCancellationsInternComponent implements OnDestroy, AfterViewInit {

  public dialogRemoveText = 'Removing orders you won\'t be able to navigate to order view from card details';

  public orderStatus = OrderStatus;
  public orderStatuses: string[];
  public provenienceOrder: string;
  public cancellationStatus: string;
  public webIdStatus = IdentStatus;
  public orderCancellationStatus = OrderCancellationStatus;
  public webIdStatusSelect = new FormControl();
  public orderCancellationStatusSelect = new FormControl();

  constructor(
    private roleService: RoleService,
    private ordersService: OrdersService,
    private ordersCancellationsInternService: OrdersCancellationsInternService,
    private changeDetectorRefs: ChangeDetectorRef,
  ) { }


  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  @ViewChild(MatButtonToggle, { static: false }) allButton: MatButtonToggle;
  @ViewChild(MatButtonToggle, { static: false }) pendingButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.ordersCancellationsInternService);

  columns = [
    { columnDef: 'cancellationDate', header: 'Cancell. date', cell: (row: Order) => `${toDateString(row.cancellationDate) || 'unknown'}` },
    { columnDef: 'cancellationStatus', header: 'Cancell. Status', cell: (row: Order) => {
        if( row.cancellationStatus == null ) {
return '-';
}
        if( row.cancellationStatus == 1 ){
          return 'Pending';
        }
        if( row.cancellationStatus == 2 ){
          return 'Done';
        }

        return 'unknown';
      }
    },
    { columnDef: 'firstName', header: 'First Name', cell: (row: Order) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last Name', cell: (row: Order) => `${row.lastName}` },
    { columnDef: 'token', header: 'Card Token', cell: (row: Order) => {
        if ( row.card != null ) {
return row.card.token;
} else {
return '-';
}
      } },
    { columnDef: 'creationDate', header: 'Creation date', cell: (row: Order) => {
        if ( row.card != null ) {
return toDateString(row.card.creationDate);
} else {
return '-';
}
      } },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: Order) => `${toDateString(row.dob) || ''}` },
    { columnDef: 'email', header: 'Email', cell: (row: Order) => `${row.email}` },
    { columnDef: 'productName', header: 'Product', cell: (row: Order) => `${row.productName}` },
    { columnDef: 'status', header: 'Order Status', cell: (row: Order) => `${row.statusName}` },
    {
      columnDef: 'countryName',
      header: 'Country',
      cellFlag: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2,
      cell: (row: OrderWithIdent) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2,
    },
    //{ columnDef: "city", header: "City", cell: (row: Order) => `${row.city}` },
    //{ columnDef: "externalRef", header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    { columnDef: 'cardName', header: 'Card name', cell: (row: Order) => `${row.cardName}` },
    { columnDef: 'invoiceNumber', header: 'Order Invoice', cell: (row: Order) => `${row.invoiceNumber || 'Voucher'}` },
    { columnDef: 'cancellationInvoiceNumber', header: 'Cancellation Invoice', cell: (row: Order) => `${row.cancellationInvoice != null && !row.cancellationInvoice.archived ? row.cancellationInvoice.code : '-'}` },
    { columnDef: 'orderDate', header: 'Order date', cell: (row: Order) => `${toDateString(row.orderDate) || ''}` },
    { columnDef: 'partnerCustomerId', header: 'Partner Customer ID', cell: (row: Order) => `${row.partnerCustomerId || ''}` },
  ];


  public dateFiltersList = [
    { name: 'dob', header: 'DOB' },
    { name: 'orderDate', header: 'Order date' },
    { name: 'cancellationDate', header: 'Cancellation date' },
  ];

  ngAfterViewInit(): void {
    //this.checkPendingButton();
    this.table.filters.someAdditionalData = this.cancellationStatus;
    this.triggerSearch();
  }


  checkAllButton() {
    try {
      this.allButton.checked = true;
      this.cancellationStatus = this.pendingButton.value === 1 ? 'pending' : (this.pendingButton.value == 2 ? 'done' : 'all');

    } catch (e) {
 console.log(e);
}
  }


  filterCancellationStatus(source: number) {
    this.cancellationStatus = (source == 0 ? 'all' : (source == 1 ? 'pending' : 'done'));
    this.triggerSearch();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
      this.table.saveTableFilters();
    }
  }




  getViewLink = (item: Order): string => item.id.toString();

  getEditLink = (item: Order): string => item.status >= OrderStatus.Shipped ? null : item.id.toString() + '/edit';

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  currentUserIsAgent() {
    return this.roleService.hasRoles('agent');
  }


  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner, "compliance"']);
  }

  filterOrdersByProvenience(source: number) {
    this.provenienceOrder = (source == 1 ? 'from_assistant' : (source == 2 ? 'from_import' : 'from_anywhere'));
    this.triggerSearch();
  }

  triggerSearch() {
    this.table.filters.someAdditionalData = this.cancellationStatus;
    this.table.filters.additionalFilterData = this.orderStatuses;
    this.onSearch();
  }

  groupTest(items: number[]) {
    if (items !== null) {
      this.orderStatuses = items.map(item => <string>OrderStatus[item]);
    }
    this.triggerSearch();
  }

  exportOrders() {
    const idList = this.table.selection.selected.map(d => d.id);
    this.ordersService
      .export(idList).subscribe(result => {
        FileHelper.saveFile(result);

        this.ordersService.getStatuses(idList).subscribe(statuses => {
          statuses.forEach(x => {
            const order = this.dataSource.data.find(y => y.id == x.id);
            if (order) {
              order.status = x.status;
              order.statusName = x.statusName;
            }
          });
          this.changeDetectorRefs.detectChanges();
          this.table.refreshTable();
        });
      });
  }



  // WebIdEvent
  onWebStatusChange() {
    this.table.filters.enumFilter = { key: 'IdentStatus', value: this.webIdStatusSelect.value };
    this.triggerSearch();
  }

  onOrderCancellationStatusChange() {
    this.table.filters.enumFilter = { key: 'OrderCancellationStatus', value: this.orderCancellationStatusSelect.value };
    this.triggerSearch();
  }


  ngOnDestroy() {
    //this.table.filters.someAdditionalData = "";
    //this.orderStatuses = null;
    this.table.saveTableFilters();
  }
}
